<template>
  <main-layout>
    <modal-send-status title="Envoie" :sending-status="status"></modal-send-status>
    <confirmation-box id="box" main-msg="Veux tu changer la clef?" @ok="RandomCode"></confirmation-box>
    <b-form class="p-4" @submit.stop.prevent @submit="Submit">
      <b-form-group label="Contenu">
        <b-form-input v-model="contenu" required></b-form-input>
      </b-form-group>
      <b-form-group label="Prix">
        <b-form-input v-model="prix" :formatter="FormatPrix" required trim></b-form-input>
      </b-form-group>
      <b-form-group label="Clef">
        <b-input-group>
          <b-form-input v-model="clef" required></b-form-input>
          <b-input-group-append>
            <b-button variant="info" @click="GenerateCode">Generer</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group label="Adresse Paypal">
        <b-form-input v-model="adresse_paypal"></b-form-input>
      </b-form-group>
      <b-form-group label="exercices">
        <b-form-select
            v-model="exercices"
            :options="options"
            multiple :select-size="10">
        </b-form-select>
      </b-form-group>
      <back-btn-toolbar>
        <b-btn variant="primary" type="submit">SAUVER</b-btn>
      </back-btn-toolbar>
    </b-form>
  </main-layout>
</template>

<script>
import {Exercice, Produit} from "@/js/caller";
import BackBtnToolbar from "@/components/back-btn-toolbar";
import ModalSendStatus from "@/components/Modals/modalSendStatus";
import ConfirmationBox from "@/components/confirmationBox"
import {DataFormat} from "@/js/utils";

export default {
  name      : "ProduitEditorVue",
  components: {ModalSendStatus, BackBtnToolbar, ConfirmationBox},
  data() {
    return {
      id            : null,
      contenu       : "",
      prix          : 0,
      clef          : "",
      adresse_paypal: "",
      exercices     : [],
      options       : [],
      status        : 0,
      confirmation  : {}
    }
  },
  methods: {
    Submit() {
      const self = this;
      const {id, contenu, prix, clef, adresse_paypal, exercices} = self;
      const finish = (status, id) => {
        self.status = status
        setTimeout(() => {
          this.$bvModal.hide("sendingLoadingScreen");
          if (id) {
            this.id = id;
            this.$router.replace({name: "ProduitEditorVue", params: {id}})
          }
        }, 2000);
      }
      self.$bvModal.show("sendingLoadingScreen")
      Produit.Save({id, contenu, prix, clef, adresse_paypal, exercices})
             .then(({id}) => finish(1, id), () => finish(2));
    },
    FormatPrix(prix) {
      const P = parseFloat(prix.replace(',', '.'));
      if (isNaN(P)) return 0;
      const comparator = prix.length - prix.replace(',', '.').indexOf('.');
      if (comparator === 1) return prix
      return (comparator < prix.length && comparator > 2) ? P.toFixed(2) : P
    },
    GenerateCode() {
      if (this.clef === "") return this.RandomCode();
      this.$bvModal.show('box');
    },
    RandomCode() {
      this.clef = DataFormat.RandomString(15)
    }
  },
  created() {
    Exercice.List().then(res => {
      this.options = res
          .sort(
              function (a, b) {
                return a.titre.toLowerCase().localeCompare(b.titre.toLowerCase());
              }
          )
          .map(({id, titre, niveau, type}) => {
            return {text: `${titre} (${niveau}/${type})`, value: id}
          });
    });
    const {id} = this.$route.params
    if (id === "new") return;
    this.id = id;
    Produit.Get(id).then(({contenu, prix, clef, adresse_paypal, exercices}) => {
      this.contenu = contenu;
      this.prix = prix;
      this.clef = clef;
      this.adresse_paypal = adresse_paypal;
      this.exercices = exercices.map(e => e.id);
    })
  }
}
</script>

<style scoped>

</style>